import React from 'react';
import { NotificationSettings, OrganizationDetails, ResponsibleTeam, SecuritySettings, SupportAndContact } from './Components';

export const AdvancedSettings = () => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-6 py-6'>
      <OrganizationDetails
          id='org-123'
          name='Acme Corp'
          industry='Technology'
          location='San Francisco'
          timeZone='PST'
          onSave={(data) => {
            console.log('Saving organization details:', data);
          }}
      />
      <SupportAndContact />
      <ResponsibleTeam />
      <NotificationSettings />
      <SecuritySettings />
    </div>
  );
};

